<div class="row">
  <div class="col-12 d-none">
    <div class="price-table-container">
      <table class="price-table w-100" *ngIf="productList">
        <tbody>
          <tr *ngFor="let productCategory of productList">
            <th>{{ 'popins.products_list.main.' + productCategory.key + '.title' | translate }}</th>
            <td>{{ productCategory.subTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>{{ 'popins.products_list.aside.total' | translate }}</th>
            <td>{{ productTotalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th>{{ 'popins.products_list.aside.totalTva' | translate }}</th>
            <td>{{ productTotalPrice * 0.2 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th class="ecofees">{{ 'popins.products_list.aside.totalDeee' | translate }}</th>
            <td class="ecofees">{{ productTotalDeee | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr>
            <th class="ecofees">{{ 'popins.products_list.aside.totalEcomob' | translate }}</th>
            <td class="ecofees">{{ productTotalEcomob | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="legacy" [innerHtml]="'popins.products_list.aside.disclaimer' | translate"></div>
  </div>

  <div class="col-12">
    <div class="header-actions">
      <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>

    <div class="modal-content-body">
      <div class="init-text pt-5" *ngIf="!productList">
        {{ 'popins.products_list.empty' | translate }}
      </div>

      <div class="product-list p-4 pr-5" *ngIf="productList">
        <table class="table product-table order">
          <ng-container *ngFor="let productCategory of productList">
            <tr class="title-row">
              <td colspan="7">
                <h3>{{ 'popins.products_list.main.' + productCategory.key + '.title' | translate }}</h3>
              </td>
            </tr>
            <tr class="product-table-label">
              <th>&nbsp;</th>
              <th>
                <span>{{ 'popins.products_list.main.columns.ref' | translate }}</span>
              </th>
              <th colspan="2">
                <span>{{ 'popins.products_list.main.columns.name' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.price' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.qty' | translate }}</span>
              </th>
              <th>
                <span>{{ 'popins.products_list.main.columns.total' | translate }}</span>
              </th>
            </tr>
            <tr *ngFor="let productRow of productCategory.products; let last = last" [class.last]="last">
              <td><img width="64" height="64" [src]="productRow.thumbnailURLSmall" /></td>
              <td class="ref">
                {{ productRow.reference }}<ng-container *ngIf="productRow.pmm"><br />{{ productRow.pmm }}</ng-container>
              </td>
              <td colspan="2">{{ productRow.name }}</td>
              <td>{{ productRow.price.current.value | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
              <td>
                <input
                  type="number"
                  min="0"
                  increment="1"
                  (change)="updatePrices()"
                  [(ngModel)]="productRow.quantity" />
              </td>
              <td>
                {{ productRow.totalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                }}<span class="ecofees" *ngIf="productRow.totalDeee > 0"
                  ><br />{{ 'popins.products_list.aside.totalDeee' | translate }}
                  {{ productRow.totalDeee | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span
                >
                <span class="ecofees" *ngIf="productRow.totalEcomob > 0"
                  ><br />{{ 'popins.products_list.aside.totalEcomob' | translate }}
                  {{ productRow.totalEcomob | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span
                >
              </td>
            </tr>
            <tr class="spacer thin">
              <td colspan="7">&nbsp;</td>
            </tr>
            <tr class="subtotal">
              <td colspan="3">&nbsp;</td>
              <td colspan="3">
                <span>{{ 'popins.products_list.main.' + productCategory.key + '.subtotal' | translate }}</span>
              </td>
              <td>{{ productCategory.subTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
            </tr>
            <tr class="spacer">
              <td colspan="7">&nbsp;</td>
            </tr>
            <ng-container *ngIf="productCategory.key == 'linears'">
              <tr class="spacer">
                <td
                  colspan="7"
                  class="text-center"
                  [innerHtml]="'popins.products_list.aside.disclaimerLinear' | translate"></td>
              </tr>
              <tr class="spacer">
                <td colspan="7">&nbsp;</td>
              </tr>
            </ng-container>
          </ng-container>

          <tr class="total">
            <td colspan="3">&nbsp;</td>
            <td colspan="3">
              <span>{{ 'popins.products_list.aside.total' | translate }}</span>
            </td>
            <td>{{ productTotalPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr class="tva">
            <td colspan="3">&nbsp;</td>
            <td colspan="3">
              <span>{{ 'popins.products_list.aside.totalTva' | translate }}</span>
            </td>
            <td>{{ productTotalPrice * 0.2 | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr class="tva">
            <td colspan="3">&nbsp;</td>
            <td colspan="3">
              <span>{{ 'popins.products_list.aside.totalDeee' | translate }}</span>
            </td>
            <td>{{ productTotalDeee | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
          <tr class="tva">
            <td colspan="3">&nbsp;</td>
            <td colspan="3">
              <span>{{ 'popins.products_list.aside.totalEcomob' | translate }}</span>
            </td>
            <td>{{ productTotalEcomob | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="footer">
      <div class="row">
        <div class="text-left col-4">
          <ng-casto-btn
            class="light-grey"
            (click)="back()"
            [label]="'popins.installation.back' | translate"></ng-casto-btn>
        </div>
        <div class="text-right col-8">
          <ng-casto-btn class="light-grey" (click)="printList()" [label]="'generic.print' | translate"></ng-casto-btn>
          <ng-casto-btn
            class="blue"
            [disabled]="!projectIsSaved"
            *ngIf="vendorEnvironment"
            (click)="order()"
            label="Suivant"></ng-casto-btn>
        </div>
      </div>
    </div>
  </div>
  @if (this.customer.context === CONFIG_CONTEXT.KITCHEN) {
    <p-dialog
      [header]="'popins.plinthWarning.title' | translate"
      [modal]="true"
      [(visible)]="warningDialogVisible"
      [style]="{ width: '30rem' }">
      <span class="p-text-secondary block mb-5">{{ 'popins.plinthWarning.text' | translate }}</span>
      <div class="d-flex justify-content-center mt-3">
        <ng-casto-btn
          class="blue"
          (click)="warningDialogVisible = false"
          [label]="'popins.plinthWarning.confirm' | translate"></ng-casto-btn>
      </div>
    </p-dialog>
  }
</div>
